export * from '@taqueria/protocol/out/types/PluginDependenciesResponse';
